module.exports = "<div class=\"footer\">\n  <div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-md-12 text-center\">\n            <div class=\"footer-btm\">\n                <span>&copy; Vergronix 2017. Designed by ZaaGIS</span>\n            </div>\n        </div>\n    </div>\n</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 16
// module chunks = 0